import { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import AppContext from '@/context/AppContext'

const useCustomCopy = key => {
  const { context } = useContext(AppContext)
  const { i18n } = useTranslation()

  const messagesForLanguage = context?.merchantInfo?.preferences?.custom_messages?.[i18n.language]
  const customMessage = messagesForLanguage?.find(message => message.key === key)

  return customMessage?.message
}

export default useCustomCopy
